module.exports = __webpack_public_path__ + "static/img/bg-subscribe-slider.42a3bc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-subscribe-slider.jpg
// module id = /zRp
// module chunks = 1